"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherPlayer = void 0;
const vue_1 = require("vue");
const StackedCards_1 = require("./StackedCards");
const PlayerMixin_1 = require("./PlayerMixin");
const PlayerStatus_1 = require("./overview/PlayerStatus");
const Card_1 = require("./card/Card");
exports.OtherPlayer = vue_1.default.component('other-player', {
    props: {
        player: {
            type: Object,
        },
        playerIndex: {
            type: Number,
        },
    },
    components: {
        'stacked-cards': StackedCards_1.StackedCards,
        Card: Card_1.Card,
    },
    mixins: [PlayerMixin_1.PlayerMixin],
    methods: {
        hideMe: function () {
            PlayerStatus_1.hidePlayerData(this.$root, this.playerIndex);
        },
        isVisible: function () {
            return this.$root.getVisibilityState('pinned_player_' + this.playerIndex);
        },
    },
    template: `<div>
            <div v-show="isVisible()">
                <div :class="'player_translucent_bg_color_' + player.color" class="other_player_header">
                    <div class="player_name">{{ player.name }} <span v-i18n>played cards</span></div>
                    <Button size="big" type="close" :onClick="hideMe" :disableOnServerBusy="false" align="right" />
                </div>

                <div class="other_player_cont menu">
                    <div v-if="player.playedCards.length > 0 || player.corporationCards !== []" class="player_home_block">
                        <div>
                            <div v-for="card in player.corporationCards" class="cardbox">
                                <Card :card="card" :actionUsed="isCardActivated(card, player)"/>
                            </div>

                            <div v-for="card in getCardsByType(player.playedCards, [getLeaderCardType()])" :key="card.name" class="cardbox">
                                <Card :card="card" :actionUsed="isCardActivated(card, player)"/>
                            </div>

                            <div v-for="card in sortActiveCards(getCardsByType(player.playedCards, [getActiveCardType()]))" :key="card.name" class="cardbox">
                                <Card :card="card" :actionUsed="isCardActivated(card, player)"/>
                            </div>

                            <stacked-cards class="player_home_block--non_blue_cards" :cards="getCardsByType(player.playedCards, [getAutomatedCardType(), getPreludeCardType()])" :player="player"></stacked-cards>
                            <stacked-cards class="player_home_block--non_blue_cards" :cards="getCardsByType(player.playedCards, [getEventCardType()])" :player="player"></stacked-cards>
                        </div>
                    </div>
                    <div v-if="player.selfReplicatingRobotsCards.length > 0" class="player_home_block">
                        <span> Self-Replicating Robots cards </span>
                        <div>
                            <div v-for="card in getCardsByType(player.selfReplicatingRobotsCards, [getActiveCardType()])" :key="card.name" class="cardbox">
                                <Card :card="card" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`,
});
//# sourceMappingURL=OtherPlayer.js.map